import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';

import * as TradeActions from 'actions/trade';
import Markets from 'components/markets';
import { filteredMarketsProductSelector, marketShowLoaderSelector } from 'selectors';
import {
  chartHistorySelector,
  roboStrategiesSelector,
  isOnlineSelector,
  isSocketReconnecting,
  yieldStrategiesSelector,
  productsWithoutCallPutSelector,
} from 'selectors/tradeSelectors';
import IState, { ICustomDispatch } from 'types/Istore';

const mapStateToProps = (state: IState) => ({
  showLoader: marketShowLoaderSelector(state),
  products: filteredMarketsProductSelector(state),
  chartHistory: chartHistorySelector(state),
  isInternetConnected: isOnlineSelector(state),
  isSocketReconnecting: isSocketReconnecting(state),
  fundsList: roboStrategiesSelector(state),
  yieldStrategies: yieldStrategiesSelector(state),
  allProductsList: productsWithoutCallPutSelector(state),
});

const mapDispatchToProps = (dispatch: ICustomDispatch<IState>) =>
  bindActionCreators(
    {
      getChartHistory: TradeActions.getChartHistory,
      getFundsList: TradeActions.getFundsList,
    },
    dispatch
  );

export default connect(mapStateToProps, mapDispatchToProps)(Markets);
